import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export default function CtaBanner() {
    const { t } = useI18n();
    const s = t.cta;
    return (
        <section
            id="cta"
            className="relative py-24 md:py-40 overflow-hidden"
            data-testid="cta-section"
        >
            <div
                aria-hidden
                className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1400px] h-[1000px] rounded-full"
                style={{
                    background:
                        "radial-gradient(ellipse at center, rgba(229,91,19,0.28) 0%, rgba(229,91,19,0.06) 30%, transparent 60%)",
                    filter: "blur(40px)",
                }}
            />

            <div className="absolute top-0 left-0 right-0 hairline" />
            <div className="absolute bottom-0 left-0 right-0 hairline" />

            <div className="container-x relative z-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="inline-flex items-center gap-3 text-[11px] font-mono uppercase tracking-[0.28em] text-[#E55B13] mb-10"
                >
                    <span className="w-8 h-px bg-[#E55B13]" />
                    {s.eyebrow}
                    <span className="w-8 h-px bg-[#E55B13]" />
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                    className="font-heading font-light text-white tracking-[-0.04em] leading-[0.95] text-[12vw] md:text-[9vw] lg:text-[7.6vw] max-w-6xl mx-auto"
                    data-testid="cta-headline"
                >
                    {s.titlePre}
                    <span className="italic font-extralight text-white/70">
                        {s.titleAccent}
                    </span>
                    {s.titlePost}
                    <span className="accent-dot" />
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{
                        duration: 1,
                        delay: 0.2,
                        ease: [0.16, 1, 0.3, 1],
                    }}
                    className="mt-8 font-body text-white/60 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto"
                >
                    {s.sub.pre}
                    <span className="text-white">{s.sub.a}</span>
                    {s.sub.sep1}
                    <span className="text-white">{s.sub.b}</span>
                    {s.sub.and}
                    <span className="text-white">{s.sub.c}</span>
                    {s.sub.post}
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{
                        duration: 1,
                        delay: 0.35,
                        ease: [0.16, 1, 0.3, 1],
                    }}
                    className="mt-12 flex flex-wrap justify-center items-center gap-3"
                >
                    <a
                        href="#contact"
                        className="btn-primary inline-flex items-center gap-2 group"
                        data-testid="cta-primary"
                    >
                        {s.primary}
                        <ArrowUpRight
                            size={16}
                            className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                        />
                    </a>
                    <a
                        href="#pricing"
                        className="btn-ghost inline-flex items-center gap-2"
                        data-testid="cta-secondary"
                    >
                        {s.secondary}
                    </a>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1, delay: 0.5 }}
                    className="mt-14 font-mono text-[11px] tracking-[0.28em] uppercase text-white/40"
                >
                    {s.location}
                </motion.div>
            </div>
        </section>
    );
}
